export const WorkplaceConfigEN = {
  "WorkplaceAdd": {
    "WorkplaceAdd": "Add work location",
    "WorkplaceEdit": "Edit work location",
    "WorkplaceDelete": "Delete work location",
    "ListWorkplace": "List work location",
    "Workplace" : "Workplace"
  },
  "WorkplaceTitle": {
    "name" : " Name Workplace",
    "WorkLocation" : "Address work location" ,
    "CurrentDepartment" : "Department",
    "status" : "Status",
    "active" : "Active",
    "inactive" : "InActive"
  },
  "placeholderWorkplace": {
    "name" : " Name Workplace",
    "WorkLocation" : "Address work location" ,
    "CurrentDepartment" : "Department"
  },
  "button": {
    "buttonSubmit": "Submit",
    "buttonUpdate": "Edit",
    "buttonCancel": "Cancel"
  },
  "NotificationWorkplace": {
    "edit": "Edit data successfully...",
    "add": "Add data successfully...",
    "delete": "Delete data successfully...",
    "question": " Do you want to delete ? ",
    "title" : "update employment type ",
    "required": " is required!"
  }
}